import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { makeRunTaskFilter, RunTaskFilterConfig, RunTaskFilterFn, RUN_TASK_FILTER_CONFIG } from "./run-task-filter";

@Component({
  selector: 'app-run-task-filter',
  templateUrl: './run-task-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RunTaskFilterComponent implements OnInit, OnDestroy {
  @Input('config')
  public readonly config = this._config;

  @Output('configChange')
  public readonly configChange = new EventEmitter<RunTaskFilterConfig>();

  @Output('filtersChange')
  public readonly filtersChange = new EventEmitter<RunTaskFilterFn[]>();

  public readonly form = this.fb.group({
    controlNo    : '',
    customer     : '',
    location     : '',
    startDatetime: '',
    actions      : this.fb.group({
      pickup         : true,
      deliver        : true,
      release        : true,
      collect        : true,
      start          : true,
      end            : true,
      breakdown      : true,
      refuel         : true,
      trailerRelease : true,
      trailerCollect : true,
      create         : true,
      accept         : true,
      reject         : true,
      emptyRunStart  : true,
      emptyRunEnd    : true,
      uploadPaperwork: true
    }),
    statuses : this.fb.group({
      notDone: true,
      done   : true
    })
  });

  public constructor(
    private fb: FormBuilder,
    @Inject(RUN_TASK_FILTER_CONFIG) private _config: RunTaskFilterConfig
  ) { }

  public ngOnInit() {
    this.form.patchValue(this.config);
  }

  public ngOnDestroy() {
    this.configChange.complete();
    this.filtersChange.complete();
  }

  public onFilter(form = this.form) {
    const config = form.value as RunTaskFilterConfig;
    this.configChange.emit(config);
    this.filtersChange.emit(makeRunTaskFilter(config));
  }

  public onReset(form = this.form) {
    form.patchValue(this._config);
    this.onFilter(form);
  }
}
